import { subscribeAdsConfigChanges, broadcastAdsConfigChanges } from './adsConfigChanges';
import { subscribeParticipantsChanges, broadcastParticipantsChanges } from './participantsChanges';

export default {
  subscribeParticipantsChanges,
  broadcastParticipantsChanges,
  subscribeAdsConfigChanges,
  broadcastAdsConfigChanges,
};
